var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HeaderBar',{attrs:{"theme":"risque-pro","service-title":_vm.$t('components.layout.appHeader.title'),"home-link":_vm.link}},[(!_vm.maintenance)?_c('HeaderMenu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }